import { LayoutProps, useAuth } from "@atsnek/jaen";

const Layout: React.FC<LayoutProps> = ({ children, pageProps }) => {
  return children;
};

export default Layout;
